"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveFilesToDiskEndpoint = exports.fileDownloadEndpoint = exports.fileUploadEndpoint = void 0;
var utils_1 = require("~shared/utils");
exports.fileUploadEndpoint = utils_1.asSingleFileFormEndpoint({
    method: 'post',
    apiPath: '/file/upload',
    fileFormName: 'file'
});
exports.fileDownloadEndpoint = utils_1.asDownloadEndpoint({
    method: 'get',
    apiPath: '/file/download/:id/:name'
});
exports.saveFilesToDiskEndpoint = utils_1.asStandardEndpoint({
    method: 'post',
    apiPath: '/files/save-to-disk'
});
//# sourceMappingURL=file.js.map